(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["promo-code"] && !Shopify.designMode) return;
  try {
    (function() {
    'use strict';

    // 初始化单个容器内的倒计时
    function initPromoCountdownForContainer(container) {
      const timerElement = container.querySelector('.countdown-timer');
      const endDateElement = container.querySelector('.discount-end-date');

      if (!timerElement || !endDateElement) {
        console.log('当前容器没有倒计时元素，跳过');
        return;
      }

      const endDate = new Date(endDateElement.textContent);
      if (isNaN(endDate.getTime())) {
        console.log('日期无效，跳过');
        return;
      }

      let intervalId = setInterval(updateTimer, 1000);

      function updateTimer() {
        if (!timerElement.isConnected || !endDateElement.isConnected) {
          clearInterval(intervalId);
          return;
        }

        const now = new Date();
        const diff = endDate - now;

        if (diff < 0) {
          timerElement.textContent = 'Expired';
          timerElement.style.color = '#999';
          clearInterval(intervalId);
          return;
        }

        // 计算天、小时、分钟、秒
        const days = Math.floor(diff / 86400000);
        const hours = Math.floor((diff % 86400000) / 3600000);
        const minutes = Math.floor((diff % 3600000) / 60000);
        const seconds = Math.floor((diff % 60000) / 1000);

        // 处理单复数
        const dayLabel = days === 1 ? 'd' : 'ds';
        const hourLabel = hours === 1 ? 'h' : 'hs';
        const minuteLabel = minutes === 1 ? 'm' : 'ms';
        const secondLabel = seconds === 1 ? 's' : 'ss';

        // 格式化输出：天, 小时, 分钟, 秒（秒始终两位数）
        timerElement.textContent = `${days} ${dayLabel}, ${hours} ${hourLabel}, ${minutes} ${minuteLabel}, ${String(seconds).padStart(2, '0')} ${secondLabel}`;
      }

      updateTimer();
    }

    function initAllPromoCountdowns() {
      const containers = document.querySelectorAll('.promo-code');
      containers.forEach(initPromoCountdownForContainer);
    }

    if (document.readyState === 'loading') {
      document.addEventListener('DOMContentLoaded', initAllPromoCountdowns);
    } else {
      initAllPromoCountdowns();
    }
  })();
  } catch(e) { console.error(e); }
})();

})();
